exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".code__321kK{display:block;white-space:pre-wrap}.dragged__BFncR{border:2px dotted red}.over__38usk{border:2px dotted #0f0}.list__2XSrj{list-style-type:none}", "", {"version":3,"sources":["/Users/sorenso/Projects/ffe-cms-retake/src/components/form/style.css"],"names":[],"mappings":"AAAA,aACI,cAAe,AACf,oBAAqB,CACxB,AAED,gBACI,qBAA2B,CAC9B,AAED,aACI,sBAA2B,CAC9B,AAED,aACI,oBAAsB,CACzB","file":"style.css","sourcesContent":[".code {\n    display: block;\n    white-space: pre-wrap   \n}\n\n.dragged {\n    border: 2px dotted #ff0000;\n}\n\n.over {\n    border: 2px dotted #00ff00;\n}\n\n.list {\n    list-style-type: none;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"code": "code__321kK",
	"dragged": "dragged__BFncR",
	"over": "over__38usk",
	"list": "list__2XSrj"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--4-2!../node_modules/postcss-loader/lib??postcss!./components/form/style.css
// module id = Q4GW
// module chunks = 0